import Contenedor from '../../components/common/Contenedor';
import { Menu } from './menu';

export const ModuloReportes = () => {
  return (
    <Contenedor title="Modulo de reportes" children={<Menu />} />
  )
}
